import { render } from "./PendingClaims.vue?vue&type=template&id=60bb3eda&scoped=true"
import script from "./PendingClaims.vue?vue&type=script&lang=js"
export * from "./PendingClaims.vue?vue&type=script&lang=js"

import "./PendingClaims.vue?vue&type=style&index=0&id=60bb3eda&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bb3eda"]])

export default __exports__